import Microgame from '../engine/Microgame.js';

export default class CountGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Compte !`, en: `Count!`, es: `¡Cuenta!` },
            controls: { fr: `Sélectionne le bouton indiquant le nombre exact de formes à l'écran`, en: `Select the button with the exact number of shapes`, es: `Toca el botón con el número exacto de formas mostradas` },
            objective: { fr: `Compte vite et donne la bonne réponse`, en: `Count fast and give the right answer`, es: `Cuenta rápido y da la respuesta correcta` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><path d="M4 10h12"/><path d="M4 14h9"/><path d="M19 6L19 18"/><path d="M16 9L19 6L22 9"/></svg>`,
            actions: [
                { type: 'tap', x: 50, y: 40, duration: 180 },
                { type: 'wait', duration: 120 },
                { type: 'tap', x: 50, y: 40, duration: 180 },
                { type: 'wait', duration: 180 },
                { type: 'tapTarget', selector: '[data-playback-validate="true"]', duration: 220 },
                { type: 'wait', duration: 600 },
            ],
            loopDuration: 2600
        };
    }
    constructor(engine) {
        super(engine);
        this.targetCount = 0;
        this.currentCount = 0;
        this.display = null;
        this.winTimer = 0;

        // Progression ralentie : on amortit la vitesse pour ne pas que ce soit "impossible" à x4,
        // mais on garde un vrai défi : 0.3 est un bon compromis entre 0.1 (trop lent) et 0.5 (trop dur).
        const speedMult = engine.speedMultiplier || 1.0;
        const adjustedSpeed = 1 + (speedMult - 1) * 0.3;

        // Base time : 4000ms. En x4 (adjusted 1.9), on aura environ ~2.1 secondes.
        this.duration = 4000 * (speedMult / adjustedSpeed);
    }

    applyConfig(config) {
        if (config.targetCount) {
            this.targetCount = parseInt(config.targetCount, 10);
            console.log("[CountGame] Config applied. Target:", this.targetCount);
        }
    }

    setup() {
        // If targetCount wasn't set by config, pick random (standard 2 to 6)
        if (this.isPlayback) {
            this.targetCount = 2;
        } else if (!this.targetCount) {
            this.targetCount = Math.floor(Math.random() * 5) + 2; // 2 to 6
        }

        this.currentCount = 0;

        // INSTRUCTION: SHOW TARGET
        // Use textContent to be safe against HTML escaping issues
        console.log("CountGame Target:", this.targetCount);

        this.engine.ui.instruction.innerHTML = '';
        this.engine.ui.instruction.appendChild(document.createTextNode('TAP THE NUMBER OF TIMES!')); // More generic top instruction

        // CENTRAL TARGET DISPLAY
        this.targetDisplay = document.createElement('div');
        this.targetDisplay.textContent = this.targetCount;
        this.targetDisplay.style.position = 'absolute';
        this.targetDisplay.style.top = '30%'; // Slightly above center
        this.targetDisplay.style.left = '50%';
        this.targetDisplay.style.transform = 'translate(-50%, -50%)';
        this.targetDisplay.style.fontSize = '80px';
        this.targetDisplay.style.fontWeight = 'bold';
        this.targetDisplay.style.color = this.primaryColor;
        this.targetDisplay.style.textShadow = `0 0 20px ${this.primaryColor}`;
        this.targetDisplay.style.zIndex = '5';
        this.container.appendChild(this.targetDisplay);

        // TAP AREA (Entire Screen mostly, but we use event listener on input element)
        // VISUAL FEEDBACK (No Number)
        this.feedback = document.createElement('div');
        this.feedback.style.position = 'absolute';
        this.feedback.style.top = '40%';
        this.feedback.style.left = '50%';
        this.feedback.style.transform = 'translate(-50%, -50%)';
        this.feedback.style.width = '100px';
        this.feedback.style.height = '100px';
        this.feedback.style.borderRadius = '50%';
        this.feedback.style.border = `4px solid ${this.secondaryColor}`;
        this.feedback.style.opacity = '0.5';
        this.container.appendChild(this.feedback);

        // CONTROLS CONTAINER
        const controls = document.createElement('div');
        controls.style.position = 'absolute';
        controls.style.bottom = '15%'; // Slightly lower to fit
        controls.style.left = '50%';
        controls.style.transform = 'translateX(-50%)';
        controls.style.display = 'flex';
        controls.style.gap = '15px';
        controls.style.alignItems = 'center';
        this.container.appendChild(controls);

        const btnStyle = `
            padding: 15px;
            font-size: 1.5rem;
            background: var(--primary-color);
            color: #000;
            font-weight: bold;
            border-radius: 30px;
            box-shadow: 0 0 15px var(--primary-color);
            cursor: pointer;
            text-align: center;
        `;

        // MINUS BUTTON
        const minusBtn = document.createElement('div');
        minusBtn.textContent = "-";
        minusBtn.className = "cyber-button";
        minusBtn.style.cssText = btnStyle + " width: 60px; height: 60px; display: flex; align-items: center; justify-content: center;";
        minusBtn.onpointerdown = (e) => {
            e.stopPropagation();
            if (this.currentCount > 0) this.currentCount--;
            this.pulseFeedback();
        };
        controls.appendChild(minusBtn);

        // VALIDATE BUTTON
        this.validateBtn = document.createElement('div');
        this.validateBtn.textContent = "VALIDATE";
        this.validateBtn.dataset.playbackValidate = 'true';
        this.validateBtn.className = "cyber-button";
        this.validateBtn.style.cssText = btnStyle + " padding: 15px 30px;";
        this.validateBtn.onpointerdown = (e) => {
            e.stopPropagation();
            this.validate();
        };
        controls.appendChild(this.validateBtn);

        // PLUS BUTTON
        const plusBtn = document.createElement('div');
        plusBtn.textContent = "+";
        plusBtn.className = "cyber-button";
        plusBtn.style.cssText = btnStyle + " width: 60px; height: 60px; display: flex; align-items: center; justify-content: center;";
        plusBtn.onpointerdown = (e) => {
            e.stopPropagation();
            this.currentCount++;
            this.pulseFeedback();
        };
        controls.appendChild(plusBtn);

        // Tap Event (Screen)
        this.onTap = this.onTap.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onTap);
    }

    onTap() {
        if (!this.active) return;

        this.currentCount++;
        this.pulseFeedback();
    }

    pulseFeedback() {
        // Visual Pulse
        this.feedback.style.transform = 'translate(-50%, -50%) scale(1.2)';
        this.feedback.style.background = `${this.secondaryColor}44`; // Semi-transparent
        setTimeout(() => {
            if (this.feedback) {
                this.feedback.style.transform = 'translate(-50%, -50%) scale(1)';
                this.feedback.style.background = 'transparent';
            }
        }, 100);
    }

    validate() {
        if (!this.active) return;

        if (this.currentCount === this.targetCount) {
            this.win();
        } else {
            // Show what they had
            this.engine.ui.instruction.innerHTML = `YOU TAPPED <span style="color:red">${this.currentCount}</span>!`;
            this.lose();
        }
    }

    update(dt) {
        // No timer accumulation logic needed anymore, just manual validation
    }

    onTimeout() {
        // If time runs out -> Fail
        return false;
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onTap);
    }
}
